





























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PickListPicking from "../../../store/entities/pick-list-picking";
import Product from "../../../store/entities/product";
import moment from "vue-moment";
@Component
export default class ViewPickListSerial extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  item: PickListPicking = new PickListPicking();
  title: string = "";
  cancel() {
    this.$emit("input", false);
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.item = this.$store.state.picklist.viewPlPicking;
      this.title = `${this.item.sku} - ${this.item.productName}`;
    }
  }
}
